<h2 mat-dialog-title>{{ isEditMode ? 'Edit' : 'Create' }} User</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="Enter email">
        <mat-error *ngIf="form.get('email')?.hasError('required')">Email is required</mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('email')">Please enter a valid email</mat-error>
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" placeholder="Enter first name">
        <mat-error *ngIf="form.get('firstName')?.hasError('required')">First name is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" placeholder="Enter last name">
        <mat-error *ngIf="form.get('lastName')?.hasError('required')">Last name is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" placeholder="Enter password">
        <mat-error *ngIf="form.get('password')?.hasError('required')">Password is required</mat-error>
        <mat-error *ngIf="form.get('password')?.hasError('minlength')">Password must be at least 6 characters</mat-error>
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Roles</mat-label>
        <mat-select formControlName="roles" multiple>
            <mat-option value="admin">Admin</mat-option>
            <mat-option value="manager">Manager</mat-option>
            <mat-option value="user">User</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('roles')?.hasError('required')">At least one role is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-field status-toggle">
      <mat-slide-toggle formControlName="isActive">
        {{ form.get('isActive')?.value ? 'Active' : 'Inactive' }}
      </mat-slide-toggle>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button style="background-color: #757575; color:white" type="submit" [disabled]="form.invalid">
      {{ isEditMode ? 'Update' : 'Create' }}
    </button>
  </mat-dialog-actions>
</form> 